import { ReactComponent as Close } from 'assets/header/close.svg'
import { useEffect, useState } from 'react'
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { ReactComponent as Right } from 'assets/nateOn/right.svg'
import { ReactComponent as Left } from 'assets/nateOn/left.svg'

interface INateOnGuideModal {
    isOpen: boolean,
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
}

const NateOnGuideModal = ({ isOpen, setIsOpen }: INateOnGuideModal) => {
    const [numPages, setNumPages] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);

    useEffect(() => {
        pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
    }, [])

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }): void => {
        setNumPages(numPages);
    }

    const prev = () => {
        setPageNumber(n => n > 1 ? n - 1 : n)
    }

    const next = () => {
        setPageNumber(n => n >= numPages ? n : n + 1)
    }

    const close = () => {
        setIsOpen(false);
        setPageNumber(1)
    }

    if (!isOpen) return null;

    return (
        <div className="z-[100] fixed">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 px-4">
                <div className="bg-white shadow-lg p-6 rounded-lg w-[1200px] tablet:w-9/10">
                    <div className='flex flex-col gap-6 font-semibold text-center'>
                        <div className='flex flex-col items-start gap-3'>
                            <div className="flex justify-between items-center mb-6 w-full">
                                <p className='mobile:text-lg text-2xl'>네이트온 팀룸 웹훅 설정 가이드</p>
                                <Close className='cursor-pointer' onClick={() => close()} />
                            </div>
                        </div>

                        <div className='relative flex-1 pb-14 max-h-[80vh] overflow-y-auto'>
                            <Document
                                file="/nateonguide.pdf"
                                onLoadSuccess={onDocumentLoadSuccess}
                                loading={<div className="flex justify-center items-center w-full h-full">로딩중...</div>}
                            >
                                <Page
                                    width={Math.min(window.innerWidth, 1200)}
                                    pageNumber={pageNumber}
                                    className={'w-full'}
                                    renderTextLayer={false}
                                />
                            </Document>

                            <div className="bottom-0 absolute flex justify-center items-center w-full h-10 container">
                                <div className="flex justify-center items-center gap-4 bg-[rgba(0,0,0,0.1)] rounded-md w-[150px] h-full">
                                    <div onClick={prev}>
                                        <Left className="w-6 cursor-pointer" fill={`${pageNumber === 1 ? '#ccc' : '#196BFF'}`} />
                                    </div>
                                    <p className="w-13 text-center">
                                        {pageNumber} / {numPages}
                                    </p>
                                    <div onClick={next}>
                                        <Right className="w-6 cursor-pointer" fill={`${pageNumber === numPages ? '#ccc' : '#196BFF'}`} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NateOnGuideModal;